import api from '@/helpers/api';

import type {
	FetchMissionsByAgencyMetaDatasParams,
	FetchMissionsByAgencyMetaDatasResponse,
	FetchMissionsParams,
	FetchMissionsResponse,
	GetMissionsRequest,
	GetMissionsResponse,
} from '@/modules/missions/types';
import type { Pagination } from '@/types/common';

const getMissions = async (
	filters: GetMissionsRequest
): Promise<GetMissionsResponse> => {
	const response = await api.request<GetMissionsResponse>({
		url: '/missions',
		method: 'GET',
		params: filters,
	});
	return response.data;
};

const getMission = async (missionId: string) => {
	const response = await api.request({
		url: `/missions/${missionId}`,
		method: 'GET',
	});
	return response.data;
};

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
const createMission = async (data: any) => {
	const response = await api.request({
		url: '/missions2/',
		method: 'POST',
		data,
	});
	return response.data;
};

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
const updateMission = async (data: { missionId: string; data: any }) => {
	const response = await api.request({
		url: `/missions/${data.missionId}`,
		method: 'PUT',
		data: data.data,
	});
	return response.data;
};

const sendCommandMission = async (data: {
	missionId: string;
	command: string;
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	data?: any;
}) => {
	const response = await api.request({
		url: `/missions/${data.missionId}/${data.command}`,
		method: 'POST',
		data: data.data || {},
	});
	return response.data;
};

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
const searchInterims = async (data: { missionId: string; data: any }) => {
	const response = await api.request({
		url: `/missions/${data.missionId}/interims`,
		method: 'POST',
		data: data.data,
	});
	return response.data;
};

const removeInterimFromMissions = async (data: {
	interimId: string;
	reason: string;
	reasonComplement?: string;
}) => {
	const response = await api.request({
		url: `/missions/removeInterim/${data.interimId}`,
		method: 'DELETE',
		data: { reason: data.reason, reasonComplement: data.reasonComplement },
	});
	return response.data;
};

const verifyWorkerConfirmMission = async (data: {
	missionId: string;
	workerId: string;
}) => {
	const response = await api.request({
		url: `/missions/${data.missionId}/confirm/${data.workerId}`,
		method: 'POST',
	});
	return response.data;
};

// --- Missions V2 ---
const fetchMissionsByAgency = async (
	params: FetchMissionsParams
): Promise<Pagination<FetchMissionsResponse>> => {
	const response = await api.request({
		url: '/missions/agency',
		method: 'GET',
		params,
	});
	return response.data;
};

const fetchMissionsByAgencyMetaDatas = async (
	params: FetchMissionsByAgencyMetaDatasParams
): Promise<FetchMissionsByAgencyMetaDatasResponse> => {
	const response = await api.request({
		url: '/missions/agency/metadata',
		method: 'GET',
		params,
	});
	return response.data;
};

export default {
	getMissions,
	getMission,
	createMission,
	updateMission,
	sendCommandMission,
	searchInterims,
	removeInterimFromMissions,
	verifyWorkerConfirmMission,
	fetchMissionsByAgency,
	fetchMissionsByAgencyMetaDatas,
};
